module.exports = __webpack_public_path__ + "img/tetosMarcelo.9591f254.webp";